import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import HomePage from "./Pages/HomePage";
import AboutPage from "./Pages/AboutPage";
import ServicesPage from "./Pages/ServicesPage";
import ContactPage from "./Pages/ContactPage";

function App() {
  return (
    <Router>
      {/* ✅ Navbar appears on all pages */}
      <Navbar />

      {/* Page content changes here */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/our-services" element={<ServicesPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
      </Routes>

      {/* ✅ Footer appears on all pages */}
      <Footer />
    </Router>
  );
}

export default App;
